import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M11.075.432l.195.11c2.621 1.512 8.835 6.24 3.543 14.966-1.046 1.711-3.55 3.71-2.713 7.586l.004.014a.5.5 0 0 1-.66.586C8.474 22.588-.392 18.414 6.66 9.956c3.827-3.863 4.804-7.187 4.012-9.17a.284.284 0 0 1 .402-.354zm4.328 16.52c1.409-1.693 2.46-5.022 2.506-6.823v-.097a.195.195 0 0 1 .363-.104c1.214 2.039 3.802 7.59-1.387 11.2-1.49 1.038-2.34 1.67-2.824 2.054l-.072.057a.486.486 0 0 1-.777-.265c-.27-1.114-.328-2.986 2.19-6.021z"
});

var SvgFireFilled = function SvgFireFilled(props) {
  return React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgFireFilled;